import useTestId from '@ori/testid-generator';
import { ArrowLeftThin, ArrowRightThin } from '@ori-ui/icons';
import { ArrowRoot } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
var icon = {
  left: ArrowLeftThin,
  right: ArrowRightThin
};
/**
 * Simple arrows for scrolling inside tabs on desktop. Using slightly modified css styles.
 */
export var Arrow = function Arrow(props) {
  var direction = props.direction,
    onClick = props.onClick,
    disabled = props.disabled;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var Icon = icon[direction];
  return /*#__PURE__*/_jsx(ArrowRoot, {
    role: "button",
    tabIndex: -1,
    disabled: disabled !== null && disabled !== void 0 ? disabled : true,
    "data-testid": getTestId('arrow'),
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Icon, {
      fontSize: "inherit",
      height: 24
    })
  });
};
//# sourceMappingURL=Arrow.js.map